import { render, staticRenderFns } from "./filter-price-range.vue?vue&type=template&id=1c89d3b8&scoped=true"
import script from "./filter-price-range.vue?vue&type=script&lang=js"
export * from "./filter-price-range.vue?vue&type=script&lang=js"
import style0 from "./filter-price-range.vue?vue&type=style&index=0&id=1c89d3b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c89d3b8",
  null
  
)

export default component.exports